export const PROFILE_COVER_HEIGHT_DESKTOP = 100;
export const PROFILE_COVER_HEIGHT_MOBILE = 130;
export const PROFILE_COVER_MIN_HEIGHT = 44;
export const PROFILE_COVER_SHRINK_RATE = 0.5;
export const PROFILE_AVATAR_SCALE_MIN = 0.6;
export const PROFILE_AVATAR_SCALE_DIVISOR = 300;

export function getProfileCoverHeight(scrollY: number, baseHeight: number): number {
  return Math.max(PROFILE_COVER_MIN_HEIGHT, baseHeight - scrollY * PROFILE_COVER_SHRINK_RATE);
}

export function getProfileAvatarScale(scrollY: number): number {
  return Math.max(PROFILE_AVATAR_SCALE_MIN, 1 - scrollY / PROFILE_AVATAR_SCALE_DIVISOR);
}

export function getProfileHeaderTitleVisible(scrollY: number, bannerHeight: number): boolean {
  return scrollY > bannerHeight + 40;
}

export function getProfileHeaderTabsOpacity(scrollY: number, bannerHeight: number): number {
  const start = bannerHeight + 60;
  const end = bannerHeight + 160;
  if (scrollY <= start) return 0;
  if (scrollY >= end) return 1;
  return (scrollY - start) / (end - start);
}
